import { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  searchDisplayTags,
  saveSearchTags,
  showPremiumSearchModal as showPremiumSearchModalAction,
} from "../../Redux/Actions";
import { debounce } from "../../Utils/_helper";
import { Dialog, DialogContent, Box, TextField } from "@material-ui/core";
import { useStyles } from "./style";
import clsx from "clsx";
import { RootState } from "../../Redux/Reducers";
import SearchIcon from "../../Assets/images/search_black.png";
import goldarrow from "../../Assets/images/goldarrow.png";
import history from "../../Utils/history";

const PremiumSearchModal = (): JSX.Element => {
  const ref = useRef<any>();
  const dispatch = useDispatch();
  const classes = useStyles();
  const [inputVal, setInputVal] = useState<string>("");
  const [inputFocus, setInputFocus] = useState<boolean>(false);

  useEffect(() => {
    if (ref?.current) {
      ref?.current?.focus();
    }
  }, [ref?.current]);

  const { showPremiumSearchModal, searchTags, displayTags, pageLoaderVisibility } = useSelector((state: RootState) => ({
    showPremiumSearchModal: state.commonReducer.showPremiumSearchModal,
    searchTags: state.themeReducer.searchTags,
    displayTags: state.themeReducer.displayTags,
    pageLoaderVisibility: state.commonReducer.pageLoaderVisibility,
  }));

  useEffect(() => {
    if (showPremiumSearchModal) {
      setInputVal("");
      dispatch(saveSearchTags([]));
    }
  }, [showPremiumSearchModal]);

  const debounceOnChange = useCallback(debounce(handleChange, 700), []);

  function handleOnchange(val: string) {
    debounceOnChange(val);
  }

  function handleChange(val: string) {
    if (val && val.length >= 1) {
      dispatch(searchDisplayTags(val));
    } else {
      dispatch(saveSearchTags([]));
    }
  }

  const toggleModal = () => {
    dispatch(showPremiumSearchModalAction(false));
  };

  const categoryItemClick = (item: { name: string; tag_id: number }) => {
    toggleModal();
    history.push(`/themes/category/${item.tag_id}`, {
      heading: item.name,
    });
  };

  const colorItemClick = (item: { name: string; tag_id: number }) => {
    toggleModal();
    history.push(`/themes/color/${item.tag_id}`);
  };

  return (
    <Dialog open={showPremiumSearchModal} maxWidth="lg" fullWidth={true} className="relative" onClose={toggleModal}>
      <DialogContent className={clsx(classes.modalBody, "h-100")}>
        <Box className="flex flex-column justify-between flex-auto w-100 h-100">
          <Box display="flex" justifyContent="center" className={clsx(classes.searchSection, "w-100 h-100")}>
            <Box component="section" display="flex" alignItems="center" flexDirection="column" className="pt4 w-100">
              <h1>What is your business category?</h1>
              <Box
                style={{
                  maxWidth: 500,
                }}
                className="relative w-100"
              >
                <TextField
                  inputRef={ref}
                  fullWidth
                  value={inputVal}
                  onChange={(e) => {
                    setInputVal(e.currentTarget.value);
                    handleOnchange(e.target.value);
                  }}
                  placeholder="ex: Jewellery"
                  className={classes.textfieldStyle}
                  onFocus={() => setInputFocus(true)}
                  onBlur={() => setInputFocus(false)}
                />
                <img src={SearchIcon} height="18" width="18" />
              </Box>
              <Box className={classes.contentWrap}>
                {searchTags && searchTags.length ? 
                  <ul>
                    {searchTags.map((item: { name: string; tag_id: number }) => {
                      return (
                        <li className="data-shown" onClick={() => categoryItemClick(item)}>
                          <span>{item.name}</span> <img src={goldarrow} alt="" />
                        </li>
                      );
                    })}
                  </ul>
                 : 
                  !pageLoaderVisibility &&
                  searchTags?.length === 0 &&
                  inputVal.length >= 1 && 
                    <ul>
                      <li className={classes.noDataShown}>Not sure what you’re looking for. Lets try another way.</li>
                    </ul>
                  
                }
              </Box>
            </Box>
          </Box>
          {!inputFocus && inputVal.length < 1 && 
            <Box className={clsx(classes.colorSection, "ph5 pv4 w-100")}>
              <h2>Try our color themes</h2>
              <Box component="section" className={classes.colorGrid}>
                {displayTags?.colors &&
                  displayTags?.colors.length &&
                  displayTags?.colors.map((color: any) => {
                    return (
                      <div className={classes.item} key={color.tag_id} onClick={() => colorItemClick(color)}>
                        <img loading="lazy" src={color.image_url} />
                        <span>{color.name}</span>
                      </div>
                    );
                  })}
              </Box>
            </Box>
          }
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PremiumSearchModal;
